module.exports = __webpack_public_path__ + "img/x-circle-yellow.12b47f86.svg";